import { render, staticRenderFns } from "./ArtistMyAccount.vue?vue&type=template&id=772b65ad&"
import script from "./ArtistMyAccount.vue?vue&type=script&lang=js&"
export * from "./ArtistMyAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports